import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/lib/SmoothScroll";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import StickyShopCTA from "@/components/StickyShopCTA";
import Home from "@/pages/Home";
import About from "@/pages/About";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App grain min-h-screen bg-[#1a1412] text-[#e8dcc4]">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <StickyShopCTA />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#231b19",
              color: "#e8dcc4",
              border: "1px solid #362b28",
              borderRadius: "0",
              fontFamily: "Outfit, sans-serif",
              fontSize: "13px",
              letterSpacing: "0.02em",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
